// extracted by mini-css-extract-plugin
export var actions = "_3z-0";
export var actionsContainer = "_3z-7";
export var border = "_3z-1";
export var childFullHeight = "_3z-f";
export var collapse = "_3z-2";
export var content = "_3z-a";
export var contentChild = "_3z-e";
export var fullscreen = "_3z-c";
export var hasLeftRadius = "_3z-k";
export var headerContainer = "_3z-3";
export var headerRow = "_3z-5";
export var hidePadding = "_3z-b";
export var navCollapsedGap = "_3z-l";
export var noScrollX = "_3z-m";
export var noScrollY = "_3z-n";
export var noTopPadding = "_3z-i";
export var optOutTopPadding = "_3z-d";
export var pageMain = "_3z-j";
export var pageOuter = "_3z-g";
export var pagePadding = "_3z-8";
export var pageScroll = "_3z-9";
export var profile = "_3z-o";
export var profileContainer = "_3z-p";
export var profileImage = "_3z-q";
export var profileMain = "_3z-r";
export var profileSubtitle = "_3z-t";
export var profileTitle = "_3z-s";
export var showLeftPadding = "_3z-h";
export var tabsPortalSlot = "_3z-6";
export var tabsWrapper = "_3z-4";
export var title = "_3z-u";